import React from 'react'
import { useLoginController } from './LoginController'
import { LoginView } from './LoginView'

const LoginPage: React.FC = () => {
    const controller = useLoginController()
    return <LoginView {...controller} />
}

export default LoginPage
